
















import { Component, Prop, Vue } from 'vue-property-decorator';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import { toggleModal } from '@/helpers/modal';
import { Getter } from 'vuex-class';
import type { CompanySetting } from '@/models/companySetting';
import type { Project } from '@/models/project';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import type { User } from '@/models/user';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import AppliedLessonsList from '@/components/knowledge/lessons/AppliedLessonsList.vue';
import { sortAppliedLessons } from '@/helpers/sortLessons';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

@Component({
    name: 'DetailedAppliedLessonTree',
    components: {
        MoreInfoModal,
        FormProjectUserPicker,
        FormDynamicFieldPicker,
        AppliedLessonsList,
    },
})
export default class DetailedAppliedLessonTree extends Vue {
    @Prop({
        required: true,
    })
    private appliedLessons;

    @Prop({
        required: true,
    })
    private tableColumns: AppliedLessonsFilter;

    @Prop({
        required: false,
    })
    private highlight: number | null;

    @Prop({
        required: false,
    })
    private type: AppliedLessonType;

    @Prop({
        required: false,
    })
    private expandEverything: boolean;

    @Prop() private isUpdating: boolean;

    private defaultOpenedDetails: number[] = [];

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('account/userInfo') private userInfo: User;
    @Getter('project/selectedProject') private selectedProject: Project;

    private tableSettings = {
        isStriped: true,
        isNarrowed: true,
        isHoverable: true,
        isPaginated: false,
    };
    private tableUpdateKey = 0;

    private toggleModal = toggleModal;
    private MoreInfoModal = MoreInfoModal;

    private lessonKey = 'lesson';

    mounted() {
        this.lessonKey =
            this.type === AppliedLessonType.PMAppliedLesson
                ? 'pm_lesson'
                : this.type === AppliedLessonType.XAppliedLesson
                ? 'x_lesson'
                : 'lesson';
    }

    get orderedLessons() {
        return this.appliedLessons.slice().sort(sortAppliedLessons);
    }

    update(lesson: AppliedLesson | PMAppliedLesson | XAppliedLesson) {
        // neutralize datepicker timezone
        if (lesson.contacttill) {
            lesson.contacttill.setMinutes(lesson.contacttill.getMinutes() - lesson.contacttill.getTimezoneOffset());
        }
        this.$emit('update', lesson);
        this.tableUpdateKey++;
    }

    private toggleUpdateAppliedLessonModal(value) {
        this.$emit('toggleUpdateAppliedLessonModal', value);
    }
}
